/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/CreateTask/Content",
  onChange
  
}) {
let eventActionDataCreateTaskValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.create_task',
})
let eventActionDataCreateTaskChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.create_task',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="event_action.data.create_task"
 value={eventActionDataCreateTaskValueData}
 onChange={eventActionDataCreateTaskChangeData}
 marginLeft={dtSpaceL}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Add task when skipped"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}